import { FileTypeEnum as e } from "../../enums/file-type-enum.mjs";
import { FilePreview as t } from "../file-preview/index.mjs";
import n from "react";
import { twMerge as r } from "tailwind-merge";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/file-preview-from-os/index.tsx
var a = n.memo(({ file: n, className: a }) => n.type.startsWith("image/") ? /* @__PURE__ */ i(t, {
	src: URL.createObjectURL(n),
	fileType: e.Image,
	alt: n.name,
	className: a,
	isThumbnail: !0,
	title: n.name
}) : n.type === "application/pdf" ? /* @__PURE__ */ i("div", {
	className: r("pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md", a),
	title: n.name,
	children: /* @__PURE__ */ i("embed", {
		src: URL.createObjectURL(n),
		type: n.type,
		className: "h-full w-full",
		style: { border: "none" }
	})
}) : n.type.startsWith("video/") ? /* @__PURE__ */ i(t, {
	src: URL.createObjectURL(n),
	fileType: e.Video,
	alt: n.name,
	className: a,
	isThumbnail: !0,
	title: n.name
}) : /* @__PURE__ */ i(t, {
	src: "",
	fileType: e.Document,
	className: a,
	isThumbnail: !0,
	title: n.name
}));
a.displayName = "FilePreviewFromOS";
//#endregion
export { a as FilePreviewFromOS };
